<link-core-view></link-core-view>
